import { Edit, useNotify, useRedirect } from 'react-admin';

import { LineItemForm, transformLineItem } from './LineItemCreate';

export const LineItemEdit = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Edit
      resource="lineItems"
      mutationMode="pessimistic"
      transform={transformLineItem}
      mutationOptions={{
        onSuccess: (data: any) => {
          notify('Updated line item');
          redirect('show', 'lineItems', data.id);
        },
      }}
    >
      <LineItemForm mode="Update" />
    </Edit>
  );
};
